import { MessageSquare, Sparkles, Zap } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const aiChatbotTemplateStarterAr: TemplateAr = {
  name: 'قالب بداية لدردشة بالـ AI',
  description:
    'قالب دردشة بالذكاء الاصطناعي جاهز تنشره على موقعك ونظام الدعم وقنوات المراسلة خلال دقائق. مجهّز مسبقاً لأشهر طلبات الدعم.',
  category: 'دعم العملاء',
  workflow: [
    { icon: MessageSquare, label: 'زائر' },
    { icon: Sparkles, label: 'حل ذكي' },
    { icon: Zap, label: 'تسليم', final: true },
  ],
  detailDescription: {
    paragraph1:
      'انشر دردشة بالـ AI تتولّى أشهر طلبات دعم العملاء من أول يوم: حالة الطلب، والإرجاع، ومساعدة الحساب، والأسئلة الشائعة، والتصعيد. مبني على منصة الوكيل الذكي من Open، يعني العقل اللي يشغّل الدردشة هو نفسه اللي يشغّل ردود الإيميل والمكالمات الصوتية. قاعدة معرفة وحدة، ومجموعة تكاملات وحدة.',
    paragraph2:
      'ركّب أداة الدردشة على موقعك، واربط الوكيل بنظام الدعم والـ CRM، وابدأ تخدم الزوار في نفس اليوم. وبعدها خصّص رسالة الترحيب، وتصنيف الطلبات، وقواعد التصعيد، وصوت العلامة. ونص المحادثة ينتقل للموظف البشري عبر نظام الدعم اللي تشغّله أصلاً، والمحادثة مرفقة معه. ولا أحد يعيد سؤال "صف لنا مشكلتك".',
  },
  benefits: [
    'يجيك مجهّز لأهم ٢٠ طلب دعم',
    'قاعدة معرفة وحدة تخدم الدردشة والإيميل والصوت',
    'أنت اللي تضبط صوت العلامة والنبرة والتوقيع',
    'التذكرة توصل لنظام الدعم عندك ومعها نص المحادثة كامل',
    'أداة تركّبها على أي موقع',
    'تجرّب قواعد الترحيب والتصعيد باختبار A/B',
  ],
};
